const ChangeEmailAddressPayload = {
  __resolveType: (arg0: any) => arg0.__typename,
};

const I18nAccountError = {
  __resolveType: (arg0: any) => arg0.__typename,
};

const ChangePasswordPayload = {
  __resolveType: (arg0: any) => arg0.__typename,
};

const DeleteAccountPayload = {
  __resolveType: (arg0: any) => arg0.__typename,
};

const Mutation = {
  changeEmailAddress: (_: any, args: any) => {
    const { newEmailAddress, password } = args.input;
    if (newEmailAddress === 'existingEmail@test.com') {
      return {
        __typename: 'ChangeEmailAddressFailure',
        error: {
          __typename: 'AccountValidationError',
          message:
            'This email address is currently in use. Please choose another email address.',
          code: '0',
          reason: 'Validation error',
          details: [
            {
              message:
                'This email address is currently in use. Please choose another email address.',
              code: '0',
              path: {
                field: 'password',
                path: '',
                __typename: 'I18nErrorPath',
              },
              reason:
                'This email address is currently in use. Please choose another email address.',
              __typename: 'I18nAccountFieldError',
            },
          ],
        },
      };
    } else if (password === 'incorrectPassword') {
      return {
        __typename: 'ChangeEmailAddressFailure',
        error: {
          __typename: 'AccountValidationError',
          message: "That's not your password",
          code: '0',
          reason: 'Validation error',
          details: [
            {
              message: "That's not your password",
              code: '0',
              path: {
                field: 'password',
                path: '',
                __typename: 'I18nErrorPath',
              },
              reason: "That's not your password",
              __typename: 'I18nAccountFieldError',
            },
          ],
        },
      };
    }
    return {
      __typename: 'ChangeEmailAddressSuccess',
      ref: '00000000-0000-0000-0000-000000000001',
    };
  },

  changePassword: (_: any, args: any) => {
    const { password } = args.input;
    if (password === 'incorrectPassword') {
      return {
        __typename: 'ChangePasswordFailure',
        error: {
          __typename: 'AccountValidationError',
          message: "That's not your password",
          code: '0',
          reason: 'Validation error',
          details: [
            {
              message: "That's not your password",
              code: '0',
              path: {
                field: 'password',
                path: '',
                __typename: 'I18nErrorPath',
              },
              reason: "That's not your password",
              __typename: 'I18nAccountFieldError',
            },
          ],
        },
      };
    }
    return {
      __typename: 'ChangePasswordSuccess',
      ref: '00000000-0000-0000-0000-000000000001',
    };
  },

  deleteAccount: (_: any, __: any) => ({
    __typename: 'DeleteAccountSuccess',
    ref: '00000000-0000-0000-0000-000000000001',
  }),
};

export {
  ChangeEmailAddressPayload,
  I18nAccountError,
  ChangePasswordPayload,
  DeleteAccountPayload,
  Mutation,
};
